import React from 'react'
import { Box } from '@mui/material'

const TabPanel = props => {
  const { children, value, index, ...other } = props
  return (
    <Box
      sx={{ height: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ height: '100%' }}>
          {children}
        </Box>
      )}
    </Box>
  )
}

export default TabPanel
